import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { triggerExecutionsBulk } from './workflowExecutions.api';
import { invalidateAfterAutomationTrigger } from './invalidateAfterAutomationTrigger';
import type { UnderwayActivity } from './types';

// Fires the BE `bulk_trigger` endpoint for the activity's pending
// executions. The move itself happened earlier (at confirm time) —
// the row only tracks the 15s "trigger or cancel" window.
export const useUnderwayDispatcher = () => {
  const queryClient = useQueryClient();

  const fire = useCallback(
    async (activity: UnderwayActivity): Promise<void> => {
      if (activity.executionIds.length === 0) {
        throw new Error('No pending executions to trigger');
      }
      await triggerExecutionsBulk(activity.executionIds);

      invalidateAfterAutomationTrigger(queryClient, {
        jobId: activity.jobId,
        candidateIds: activity.candidates.map((c) => c.id),
      });
    },
    [queryClient]
  );

  return { fire };
};
